<div *ngIf="isTokenValid === null">
    <div class="main-linkedin-callback">
        <div class="container"> 
            <img src="/assets/spinner.gif" alt="Cargando..." style="width: 65px; height: 65px;">
        </div>
    </div>
</div>

<div *ngIf="isTokenValid === false">
    <div class="error-template">
        <div class="main-linkedin-callback">
          <div class="container">
            <div class="left-section">
              <img src="/assets/logo_2x.png" alt="Conectio Logo" class="logo">
              <h2 style = "color: red;">¡ERROR!</h2>
              <p>El login con linkedin ha fallado. <br>Código de error: L-001</p>
            </div>
            <div class="right-section">
              <img src="/assets/error-token.webp" alt="Success Illustration" class="illustration" style = "border-radius: 40px;">
            </div>
          </div>
        </div>
    </div>  
</div>